require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es6.array.species.js
// module id = 1218
// module chunks = 168707334958949